import React from 'react';
import styled from '@emotion/styled';
import { Text, colors } from '@innovationdepartment/proxima-ui';

const BillingSectionWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${colors.neutral20};
  padding: 16px 16px 32px;
`;

const BillingSectionTitleWrapper = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid ${colors.neutral10};
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const BillingSectionContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PlanStatusIndicator = styled.div<{ isActive: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ isActive }) => (isActive ? '#00AD78' : colors.neutral40)};
`;

const PlanStatusBadge = styled.div<{ isActive: boolean }>`
  align-items: center;
  border-radius: 14px;
  display: flex;
  gap: 8px;
  height: 28px;
  padding: 6px 12px 6px 8px;
  background: ${({ isActive }) => (isActive ? colors.green5 : colors.neutral10)};
  color: ${({ isActive }) => (isActive ? colors.green80 : colors.neutral60)};
`;

const BillingSection: React.FC<{
  title: React.ReactNode | string;
  isActive: boolean;
}> = ({ children, title, isActive }) => {
  const StatusIndicator = (
    <PlanStatusBadge isActive={isActive}>
      <PlanStatusIndicator isActive={isActive} />
      <span>{isActive ? 'Active' : 'Inactive'}</span>
    </PlanStatusBadge>
  );

  return (
    <BillingSectionWrapper>
      <BillingSectionTitleWrapper>
        <div>{typeof title === 'string' ? <Text variant="subhead1">{title}</Text> : title}</div>
        {StatusIndicator}
      </BillingSectionTitleWrapper>
      <BillingSectionContentWrapper>{children}</BillingSectionContentWrapper>
    </BillingSectionWrapper>
  );
};

export default BillingSection;
